import { Koi } from '@ksyos/koi';
import type { TypedSchema } from '@common/validation/utils/typedSchemaType';
import { AstmaCopdOpties, ComorbiditeitenMedicatieOpties } from '@common/customControls/bariatrics';
import { addAllowNull } from '@common/validation/utils/addAllowNull';
import type {
    BariPreNurseSpecialistMedScreeningReportDataV2,
    ComorbiditeitenV2,
} from './bariPreNurseSpecialistMedScreeningReportDataV2';
import {
    bariPreNurseSpecialistMedScreeningReportBaseDraft,
    bariPreNurseSpecialistMedScreeningReportBaseFinal,
    ComorbiditeitenFinal,
} from '../bariPreNurseSpecialistMedScreeningReportSchema';

const comorbiditeitenFinalV2: TypedSchema<ComorbiditeitenV2> = {
    ...ComorbiditeitenFinal,
    chronische_longziekte: Koi.boolean().allow(null),
    depressie: Koi.koi().enum(ComorbiditeitenMedicatieOpties),
    longziekte_astma_of_copd: Koi.koi().enum(AstmaCopdOpties),
};

const bariPreNurseSpecialistMedScreeningReportFinalV2: TypedSchema<BariPreNurseSpecialistMedScreeningReportDataV2> = {
    ...bariPreNurseSpecialistMedScreeningReportBaseFinal,
    ...comorbiditeitenFinalV2,
};

const bariPreNurseSpecialistMedScreeningReportDraftV2: TypedSchema<BariPreNurseSpecialistMedScreeningReportDataV2> = {
    ...addAllowNull(comorbiditeitenFinalV2),
    ...bariPreNurseSpecialistMedScreeningReportBaseDraft,
};

export const bariPreNurseSpecialistMedScreeningReportDraftSchemaV2 = Koi.object(
    bariPreNurseSpecialistMedScreeningReportDraftV2
);
export const bariPreNurseSpecialistMedScreeningReportFinalSchemaV2 = Koi.object(
    bariPreNurseSpecialistMedScreeningReportFinalV2
);
